<template>
  <div class="wrap">
    <ImmersionHeader
      ref="ImmersionHeader"
      uiTheme="globalOne"
      leftIconClassName="icon-v3_outlined_back"
      :isBackShadow="true"
      @BackCK="closePageFn"
    />
    <!-- init loading -->
    <template v-if="initLoading">
      <LoadingMask />
    </template>
    <!-- no data -->
    <template v-if="!initLoading && !hasData">
      <NetworkPage class="bg-white" @update-again="updateAgain" />
    </template>
    <!-- page -->
    <template v-if="!initLoading && hasData">
      <div class="empty_div" :style="{ paddingTop: headerHeight + 'px' }"></div>
      <div class="main_box">
        <div class="top_box">
          <div v-if="pageInfo.brandIcon" class="top_box_img">
            <img :src="pageInfo.brandIcon" />
          </div>
          <div class="top_box_title">{{ pageInfo.brandName }}</div>
        </div>
        <div class="content_box">
          <h5 class="main_title">{{ pageInfo.mainTitle }}</h5>
          <p class="sub_title">{{ pageInfo.subTitle }}</p>
          <div class="content_input-box">
            <div class="input_info">
              <div class="icon_left">
                <img v-if="isBinded" src="../imgs/card_grey_select.png" />
                <img v-else src="../imgs/card_black_select.png" />
              </div>
              <input
                ref="inputRef"
                v-model="inputTipValue"
                type="text"
                inputmode="numeric"
                :placeholder="$t('FoodC_1_UGRq_VTHx')"
                :maxlength="ruleMaxLengthNumber"
                class="input-style"
                :class="isBinded && 'bind-style'"
                :disabled="isBinded"
                @input="handleInput"
                @focus="handleFocus"
              />
              <div class="icon_right">
                <i
                  v-if="inputTipValue && !isBinded"
                  class="icon-filld_close"
                  @click="inputTipValue = ''"
                ></i>
              </div>
            </div>
            <div v-if="errMsgInfo" class="err_msg">
              <i class="icon-v3_outlined_information"></i>{{ errMsgInfo }}
            </div>
          </div>
          <div class="content_tips-box">
            <p v-html="pageInfo.lawText" />
          </div>
        </div>
        <div class="footer_box">
          <go-button :type="btnType" :disabled="btnDisabled" @click="clickBtn">{{
            btnText
          }}</go-button>
        </div>
      </div>
    </template>
    <!-- 弹窗 -->
    <van-popup v-model="pupupShow" class="popup_style" :close-on-click-overlay="false">
      <div v-if="pageInfo.alertPage" class="popup_box">
        <h5 class="title">{{ pageInfo.alertPage.mainTitle }}</h5>
        <p class="msg">{{ pageInfo.alertPage.subTitle }}</p>
        <div class="btns">
          <go-button class="mb20" type="primary" @click="clickAgainRemoveBtn">{{
            $t('FoodC_1_zbTm_gzFe')
          }}</go-button>
          <go-button type="secondary" @click="clickPopupBtnCancel">{{
            $t('FoodC_1_AeFt_EzNz')
          }}</go-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import { Popup } from 'vant'
import { isEmpty } from 'lodash-es'
import '@/go-design-ui.js'
import { sleep } from '@/common/js/helpers'
import ImmersionHeader from '@/components/immersionHeader/index.vue'
import LoadingMask from '@/components/loading/loading-mask.vue'
import NetworkPage from '@/components/abnormal-page/network.vue'
import { apiGetShopMemberInfo, apiBindShopMember } from '@/api/shopMember/index.js'
import {
  sailing_c_x_shop_b_membership_page_sw,
  sailing_c_x_shop_b_membership_page_link_ck,
  sailing_c_x_shop_b_membership_page_popup_sw,
  sailing_c_x_shop_b_membership_page_popup_ck,
} from '../trackEvent'
Vue.use(Popup)

export default {
  name: 'ShopMemberBind',
  components: {
    ImmersionHeader,
    LoadingMask,
    NetworkPage,
  },
  data() {
    return {
      /** @desc 上层来源参数 */
      shopId: '',
      sourceType: 0, // 1: 商超 2: 提单
      /** @desc 页面数据 */
      initLoading: false,
      pageInfo: {},
      headerHeight: 0,
      inputTipValue: '',
      pupupShow: false,
      ruleMaxLengthNumber: 100,
      ruleStartNumber: '', // 开头数字
      errMsgInfo: '', // Error message
      lawLink: '', // 法律链接

      ckLoading: false, // 按钮loading
    }
  },
  computed: {
    hasData() {
      return !isEmpty(this.pageInfo)
    },
    isBinded() {
      return this.pageInfo?.isBinded
    },
    btnType() {
      return this.isBinded ? 'secondary' : 'primary'
    },
    btnDisabled() {
      return !this.inputTipValue
    },
    btnText() {
      return this.pageInfo?.isBinded ? this.$t('FoodC_1_gJQN_sqIt') : this.$t('FoodC_1_tSXl_EXCL')
    },
  },
  created() {
    const shopId = this.$route?.query?.shopId || ''
    const sourceType = +this.$route?.query?.source || 0
    this.shopId = shopId
    this.sourceType = sourceType
    this.init()
  },
  mounted() {
    this.getGlobalParams()
  },
  methods: {
    ...mapActions({ getGlobalParams: 'getGlobalParams' }),
    async init() {
      this.initLoading = true
      const res = await apiGetShopMemberInfo({ shopId: this.shopId })

      if (res?.errno === 0) {
        const { data = {} } = res
        this.pageInfo = data
        this.inputTipValue = data?.cardNumber || ''
        this.getRules(data?.verificationRules || [])
        this.lawLink = data?.lawLink || ''
        console.log('API DATA:', data)
        sailing_c_x_shop_b_membership_page_sw({
          shop_id: this.shopId,
          source: this.sourceType,
          status: data?.isBinded ? 1 : 2,
        })
      }

      this.initLoading = false
      this.getHeaderHeight()
      this.$nextTick(() => {
        if (document.querySelector('.fe_tag')) {
          document.querySelector('.fe_tag').addEventListener('click', this.handleUrlClick)
        }
      })
    },
    getRules(info) {
      info.forEach(item => {
        if (item.ruleName === 'cardNumberLength') {
          this.ruleMaxLengthNumber = +item.ruleValue || 50
        }
        if (item.ruleName === 'cardPrefixFor4') {
          this.ruleStartNumber = item.ruleValue
        }
      })
    },
    handleUrlClick() {
      if (this.lawLink) {
        this.SodaBridge('openPage', {
          target: 'blank',
          url: this.lawLink,
        })
      }
    },
    // 返回上一页
    closePageFn() {
      this.SodaBridge('closePage')
    },
    getHeaderHeight() {
      this.headerHeight = this.$refs?.ImmersionHeader?.$el?.offsetHeight || 0
    },
    handleInput(event) {
      let inputValue = event.target.value
      inputValue = inputValue.replace(/[^0-9]/g, '')
      this.inputTipValue = inputValue

      try {
        if (
          this.inputTipValue &&
          this.ruleStartNumber &&
          this.inputTipValue.length > this.ruleStartNumber.length - 1 &&
          !this.inputTipValue.startsWith(this.ruleStartNumber + '')
        ) {
          this.errMsgInfo = this.$t('FoodC_1_wrbv_ghhe')
        } else {
          this.errMsgInfo = ''
        }
      } catch (err) {
        this.errMsgInfo = ''
      }
    },
    // 底部按钮
    async clickBtn() {
      if (this.isBinded) {
        sailing_c_x_shop_b_membership_page_popup_sw({
          shop_id: this.shopId,
          source: this.sourceType,
        })
        this.pupupShow = true
        return
      }

      if (this.ckLoading) {
        return
      }
      this.ckLoading = true

      let res = {}
      try {
        res = await this.handleBindMember(1)
      } catch (err) {
        console.log('api err:', err)
      }
      this.ckLoading = false

      if (res?.errno === 0) {
        // 操作成功
        const toast = this.$createGoToast({
          text: this.$t('FoodC_1_qiwJ_ERdV'),
          time: 1500,
          type: 'positive',
        })
        toast.show()
        sailing_c_x_shop_b_membership_page_link_ck({
          shop_id: this.shopId,
          source: this.sourceType,
          link_result: 1,
        })

        this.emitAppBindSuccess()
        await sleep(1500)
        this.closePageFn()
      } else {
        // 操作失败
        this.errMsgInfo = res?.errmsg

        sailing_c_x_shop_b_membership_page_link_ck({
          shop_id: this.shopId,
          source: this.sourceType,
          link_result: 2,
          link_failure_reason: res?.errno, // 1(会员卡号未存在)、2(会员卡号已被其他账号绑定)
        })
      }
    },
    // 弹窗解绑按钮
    async clickAgainRemoveBtn() {
      if (this.ckLoading) {
        return
      }
      this.ckLoading = true

      sailing_c_x_shop_b_membership_page_popup_ck({
        shop_id: this.shopId,
        source: this.sourceType,
        button_type: 1,
      })

      let res = {}
      try {
        res = await this.handleBindMember(2)
      } catch (err) {
        console.log('api err:', err)
      }
      this.ckLoading = false

      this.pupupShow = false
      if (res?.errno === 0) {
        const toast = this.$createGoToast({
          text: this.$t('FoodC_1_biry_lDbX'),
          time: 1500,
          type: 'positive',
        })
        toast.show()

        this.emitAppBindSuccess()
        await sleep(1500)
        this.closePageFn()
      } else {
        this.errMsgInfo = res?.errmsg
      }
    },
    // 绑定&解绑
    async handleBindMember(operation) {
      const res = await apiBindShopMember({
        shopId: this.shopId,
        cardNumber: this.inputTipValue,
        operation, // 1 绑定 2 解绑
      })
      return res
    },
    // 刷新页面
    updateAgain() {
      this.$router.go(0)
    },
    handleFocus() {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }, 100)
    },
    clickPopupBtnCancel() {
      sailing_c_x_shop_b_membership_page_popup_ck({
        shop_id: this.shopId,
        sourceType: this.sourceType,
        button_type: 2,
      })
      this.pupupShow = false
    },
    // 通知app绑定成功
    emitAppBindSuccess() {
      if (+this.sourceType === 2) {
        // 提单通知
        this.SodaBridge('customer.webEventHandleResult', {
          type: 1, // 绑定、解绑商家会员
          status: 1, // 0：失败（默认） 1:成功  2:取消
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';
.bg-white {
  background-color: #fff !important;
}

.wrap {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.top_box {
  box-sizing: border-box;
  width: 100%;
  padding: 40px 40px 0;
  display: flex;
  align-items: center;
  .top_box_img {
    img {
      width: 120px;
      height: 120px;
      border-radius: 24px;
      object-fit: cover;
    }
  }
  .top_box_title {
    max-width: 560px;
    margin-left: 19px;
    font-family: DiDiSans-Pro-ExtraBold;
    font-size: 40px;
    color: #1a1a1a;
    letter-spacing: 0;
    line-height: 56px;
    @include ellipsis(2);
  }
}

.content_box {
  padding: 68px 40px;
  padding-bottom: 180px;
  .main_title {
    font-family: DiDiSans-Pro-Bold;
    font-size: 40px;
    color: #1a1a1a;
    line-height: 56px;
  }
  .sub_title {
    padding-top: 12px;
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #0b0b0d;
    line-height: 36px;
  }
  .content_input-box {
    margin-top: 32px;
    .err_msg {
      margin-top: 12px;
      display: flex;
      align-items: center;
      i {
        font-size: 30px;
        margin-right: 7px;
      }
      font-family: DiDiSans-Pro-Regular;
      font-size: 24px;
      color: #f2183d;
      line-height: 32px;
    }
  }
  .content_tips-box {
    padding-top: 32px;
    font-family: DiDiSans-Pro-Regular;
    font-size: 24px;
    color: #89898c;
    line-height: 32px;
    ::v-deep span {
      color: #ff5f14;
    }
  }
}

.input_info {
  display: flex;
  font-size: 28px;
  width: 100%;
  height: 100px;
  background: #f5f5f7;
  border-radius: 32px;
  align-items: center;
  .icon_left {
    width: 74px;
    text-align: right;
    img {
      width: 36px;
      height: 36px;
    }
  }
  .icon_right {
    width: 74px;
    i {
      font-size: 36px;
      color: #cacacc;
    }
  }
  .input-style {
    border: none;
    font-size: 28px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    height: 70px;
    line-height: 70px;
    background: #f5f5f7;
    caret-color: #ff7a45;
    &.bind-style {
      color: #89898c;
      opacity: 1; /* 防止 iOS 自动降低透明度 */
    }
  }
  .input-style::placeholder {
    font-family: DiDiSans-Pro-Medium;
    font-size: 28px;
    color: #89898c !important;
  }
  /* 光标聚焦时 */
  input.input-style:focus {
    outline: none; /* 去掉聚焦时的默认边框 */
    border: none !important; /* 聚焦时改变边框颜色 */
  }
  input:disabled {
    -webkit-text-fill-color: #89898c !important; /* 强制覆盖 iOS 默认样式 */
    color: #89898c !important;
    opacity: 1 !important; /* 防止 iOS 自动降低透明度 */
    -webkit-opacity: 1 !important; /* 旧版 iOS 兼容 */
  }
}

.footer_box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 160px;
  background-color: #fff;
  padding: 0 32px;
  box-sizing: border-box;
}

.popup_style {
  border-radius: 40px;
}
.popup_box {
  width: 590px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 40px;
  .title {
    padding-top: 40px;
    font-family: DiDiSans-Pro-Bold;
    font-size: 40px;
    color: #0b0b0d;
    line-height: 56px;
  }
  .msg {
    padding-top: 20px;
    font-family: DiDiSans-Pro-Regular;
    font-size: 32px;
    color: #0b0b0d;
    line-height: 40px;
    word-wrap: break-word;
  }
  .btns {
    padding-top: 48px;
    padding-bottom: 32px;
    .mb20 {
      margin-bottom: 20px;
    }
  }
}
</style>
